import { adminHttpClient } from '../../commons/adminHttpClient'

export interface ReviewReport {
  totalPending: number
  totalActionRequired: number
  totalFtaYtd: number
  totalFtaLast2Months: number
}

const getReviewReport = (): Promise<ReviewReport[]> => {
  return adminHttpClient.get('/DocReview/ReviewReport')
}

export default getReviewReport
